// Browser check
export const isBrowser = typeof window !== 'undefined';

export const Auth = {
  TOKEN: "Authorization",
  EXPIRING_IN_DAYS: 1000 * 60 * 60 * 24 * 180, // 180 days
  ACCESS_TOKEN_EXPIRY: 1000 * 60 * 60  // 1 hour
}

export const cookieUtils = {
  create: function (name: string, value: string, expireTime: number, domain: string) {
    if (!isBrowser) return;

    expireTime = !!expireTime ? expireTime : 30 * 60 * 1000; // 30 minutes
    var date = new Date();
    date.setTime(date.getTime() + expireTime);
    var expires = '; expires=' + date.toUTCString();
    let path = "/"

    if (process.env.NODE_ENV !== "development") {
      // RFC 6265: Domain attribute must be a hostname WITHOUT a port.
      // window.location.host includes the port, which causes browsers to silently
      // reject the cookie. Prefer the explicit `domain` arg, fall back to hostname.
      const cookieDomain = domain || window?.location?.hostname;
      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; Path=${path}; Domain=${cookieDomain}; Secure; SameSite=None;`;
    } else {
      document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
    }
  },

  get: function (name: string) {
    if (!isBrowser || typeof document === 'undefined') return null;

    try {
      var value = '; ' + document.cookie;
      var parts = value.split('; ' + name + '=');
      if (parts.length === 2) {
        return parts.pop()?.split(';').shift();
      }
    } catch (e) {
      console.warn('Error reading cookie:', e);
    }
    return null;
  },

  delete: function (name: string) {
    if (!isBrowser || typeof document === 'undefined') return;
    try {
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    } catch (e) {
      console.warn('Error deleting cookie:', e);
    }
  },

  deleteV2: function (name: string, path = "/") {
    let cookieStr = `${encodeURIComponent(name)}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=${path};`;
    if (process.env.NODE_ENV !== "development") {
      cookieStr += ` Domain=${window?.location?.hostname};`;
    }
  
    // Set it — browser will remove it
    document.cookie = cookieStr;
  }
};